import { z } from 'zod';
export const ChatChartDataSchema = z.object({
    type: z.enum(['bar', 'line', 'area', 'pie', 'composed']),
    title: z.string().optional(),
    data: z.array(z.record(z.string(), z.union([z.string(), z.number()]))),
    config: z.object({
        xKey: z.string(),
        series: z.array(z.object({
            dataKey: z.string(),
            name: z.string().optional(),
            color: z.string().optional(),
            type: z.enum(['bar', 'line', 'area']).optional(), // for composed charts
        })),
        yAxisLabel: z.string().optional(),
        xAxisLabel: z.string().optional(),
        showGrid: z.boolean().optional(),
        showLegend: z.boolean().optional(),
    }),
});
